import { teamRequestsCopy as t } from "./copy.ts";
import { place } from "./place.ts";

const count = { view: "pedidos", route: "GET /api/pedidos", field: "abertos", words: t.gaveta } as const;

export const drawer = { label: t.lugar, href: place.path, count };
